import React, { ReactNode, useRef } from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

import * as S from './styles';
import { Either } from '../../utils/propsUtil';
import * as Form from '@radix-ui/react-form';
import { InputTitle } from '../Form/Components/inputTitle';
import { InputMensage } from '../Form/Components/InputMensage';
import { CheckIcon } from '@radix-ui/react-icons';
import { useTheme } from '../../utils/context/themeContext';

interface Props0 {
  title?: string | undefined;
  value?: boolean | undefined;
  setValue?: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  defaultChecked?: boolean | undefined
  key?: number
  style?: React.CSSProperties

  children?: ReactNode
  disabled?: boolean
}

interface Props1 {
  label?: string | undefined
  msgError?: string | undefined;
  form: boolean
  name: string
}

interface Props2 {

}

export type CheckboxProps = Props0 & Either<Props1, Props2>;

export function Checkbox(props: CheckboxProps) {
  const { theme } = useTheme();
  const inputRef = useRef<HTMLInputElement>(null);
  const inputRefForm = useRef<HTMLButtonElement | null>(null);

  function handleAreaClick() {
    inputRef && inputRef.current?.click();
    inputRef && inputRefForm.current?.click();
  }

  function handleOnCheckedChange(v : CheckboxPrimitive.CheckedState){
     props.setValue != null && props.setValue(Boolean(v)) 
  }


  function handleOnChange(){
     props.setValue != null && props.setValue(Boolean(!props.value)) 
  }


  function input()  {
    return (
      props.form && props.name ?
        <Form.Field data-testid="checkbox-input" style={props.style} key={props.key} name={props.name} asChild>
          <S.CheckboxPrimitiveRoot disabled={props.disabled} ref={inputRefForm} defaultChecked={props.defaultChecked} checked={props.value} onCheckedChange={handleOnCheckedChange}>
            <CheckboxIndicator asChild className="CheckboxIndicator">
              <CheckIcon color={theme.colors.primary} />
            </CheckboxIndicator>
          </S.CheckboxPrimitiveRoot>
        </Form.Field>
        :
        <S.Checkbox data-testid="checkbox-input" disabled={props.disabled} ref={inputRef} key={props.key} defaultChecked={props.defaultChecked} checked={props.value} onChange={handleOnChange} value={Number(props.value)} type={"checkbox"} />
    )
  }

  return (
    <S.CheckboxArea>
      <S.CheckboxInput>
        {props.form ?
          <Form.Field className="FormField" name="email">
            <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
              <InputTitle form={props.form} label={props.title} />
              <InputMensage form={props.form} label={props.label} type={undefined} />
              <InputMensage form={props.form} label={props.msgError} type={"valueMissing"} />
            </div>
            {input()}
          </Form.Field>
          :
          <>
            <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
              <InputTitle form={props.form} label={props.title} />
            </div>
            {input()}
          </>
        }
      </S.CheckboxInput>

      {
        props.children &&
        <S.CheckboxChild onClick={handleAreaClick}>
          {props.children}
        </S.CheckboxChild>
      }
    </S.CheckboxArea>
  )
}

// type CheckboxIndicatorProps = CheckboxPrimitive.CheckboxIndicatorProps &
//   React.ComponentProps<typeof S.CheckboxIndicator> & {}
// Comentado porque está vazio, usar caso necessário

export function CheckboxIndicator ({ children, ...props }: /* CheckboxIndicatorProps */ CheckboxPrimitive.CheckboxIndicatorProps){
  return (
    <S.CheckboxIndicator {...props} asChild>
      {children}
    </S.CheckboxIndicator>
  )

}
